/* global axios */
import ApiClient from '../ApiClient';

const appendFields = (body, payload) => {
  body.append('service[name]', payload.name.trim());
  body.append('service[description]', (payload.description || '').trim());
  body.append('service[price]', (payload.price || '').trim());
  body.append('service[duration]', (payload.duration || '').trim());
  return body;
};

class ArrowsAiServicesAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/services`);
  }

  create({ assistantId, payload } = {}) {
    return axios.post(
      `${this.url}/${assistantId}/services`,
      appendFields(new FormData(), payload)
    );
  }

  update({ assistantId, id, payload } = {}) {
    return axios.patch(
      `${this.url}/${assistantId}/services/${id}`,
      appendFields(new FormData(), payload)
    );
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/services/${id}`);
  }

  import({ assistantId, file } = {}) {
    const body = new FormData();
    body.append('file', file);
    return axios.post(`${this.url}/${assistantId}/services/import`, body);
  }

  exportWorkbook({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/services/export`, {
      responseType: 'blob',
    });
  }
}

export default new ArrowsAiServicesAPI();
